let totalAmountCartPrice = 0;
let birthStones = [];

// Loading overlay management functions
function showLoadingOverlay() {
  const loadingOverlay = document.getElementById("loading-overlay");
  const addToCartButton = document.getElementById("AddToCartButton");
  
  if (loadingOverlay) {
    loadingOverlay.classList.remove("hidden");
  }
  
  // Disable the button while loading
  if (addToCartButton) {
    addToCartButton.disabled = true;
    addToCartButton.style.opacity = "0.6";
    addToCartButton.style.cursor = "not-allowed";
  }
}

function hideLoadingOverlay() {
  const loadingOverlay = document.getElementById("loading-overlay");
  const addToCartButton = document.getElementById("AddToCartButton");
  
  if (loadingOverlay) {
    loadingOverlay.classList.add("hidden");
  }
  
  // Re-enable the button based on diamond selection
  updateButtonState();
}

// Function to clear diamond selection from session storage
function clearDiamondSelection() {
  sessionStorage.removeItem("selectedDiamond");
  console.log("✅ Diamond selection cleared");
}

// Function to check if diamond is selected and update button state
window.updateButtonState = function() {
  const addToCartButton = document.getElementById("AddToCartButton");
  if (!addToCartButton) return;
  
  // If this is a Moissanite product, the diamond selection is not required
  const isMoissaniteProduct = !!(window.productDetails && window.productDetails.isMoissanite);
  if (isMoissaniteProduct) {
    addToCartButton.disabled = false;
    addToCartButton.style.opacity = "1";
    addToCartButton.style.cursor = "pointer";
    addToCartButton.style.backgroundColor = ""; // Reset to default
    addToCartButton.textContent = "Add Custom Ring to Cart";
    return;
  }
  
  // Check if diamond is selected
  const selectedDiamondJSON = sessionStorage.getItem("selectedDiamond");
  const hasDiamondSelected = selectedDiamondJSON && selectedDiamondJSON !== "null" && selectedDiamondJSON !== "undefined";
  
  if (hasDiamondSelected) {
    try {
      const diamondData = JSON.parse(selectedDiamondJSON);
      if (diamondData && Object.keys(diamondData).length > 0) {
        // Diamond is selected - enable button
        addToCartButton.disabled = false;
        addToCartButton.style.opacity = "1";
        addToCartButton.style.cursor = "pointer";
        addToCartButton.style.backgroundColor = ""; // Reset to default
        return;
      }
    } catch (e) {
      console.warn("Error parsing diamond data:", e);
    }
  }
  
  // No diamond selected - disable button
  addToCartButton.disabled = true;
  addToCartButton.style.opacity = "0.5";
  addToCartButton.style.cursor = "not-allowed";
  addToCartButton.style.backgroundColor = "#9CA3AF"; // Gray out the button
  addToCartButton.textContent = "Please Select a Diamond First";
}

document.addEventListener("DOMContentLoaded", function () {
    const redirectDiv = document.getElementById("redirectDiv");
  if(redirectDiv){
    console.log("GETTING PARENT ID");
    return;
  }
  const variantIdInput = document.querySelector("form[action='/cart/add'] input[name='id']");
  const engraving = document.getElementById("engraving");
  const paymentOptionGroup = document.getElementById("payment-option-group");
  const paymentInfoBox = document.getElementById("payment-info");
  const paymentInfoBoxFull = document.getElementById("payment-info-full");

  fetchBirthStones();
  // Toggle info box for payment option
  if (paymentOptionGroup) {
    paymentOptionGroup.addEventListener('change', function(e) {
      const selected = document.querySelector('input[name="payment-option"]:checked');
      if (paymentInfoBox) {
        if (selected && selected.value === 'deposit') {
          paymentInfoBox.classList.remove('hidden');
        } else {
          paymentInfoBox.classList.add('hidden');
        }
      }
      if (paymentInfoBoxFull) {
        if (selected && selected.value === 'full') {
          paymentInfoBoxFull.classList.remove('hidden');
        } else {
          paymentInfoBoxFull.classList.add('hidden');
        }
      }
    });
  }

  const customAddBtn = document.getElementById("AddToCartButton");

  // Initialize button state based on diamond selection
  updateButtonState();

  // Listen for changes in session storage (when diamond is selected/deselected)
  window.addEventListener('storage', function(e) {
    if (e.key === 'selectedDiamond') {
      updateButtonState();
    }
  });

  // Also check for changes when the page becomes visible (for same-tab updates)
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) {
      updateButtonState();
    }
  });

  if (customAddBtn) {
    customAddBtn.addEventListener("click", async () => {
      // Prevent multiple clicks
      if (customAddBtn.disabled) {
        return;
      }
      
      // Show loading overlay
      showLoadingOverlay();
      
      try {
        await createDraftOrder(); // your custom logic
      } catch (error) {
        console.error("Error creating draft order:", error);
        // Hide loading overlay on error
        hideLoadingOverlay();
        alert("There was an error creating your order. Please try again.");
      }
    });
  }
});

async function createDraftOrder() {
  // Set a timeout to hide loading overlay after 30 seconds (fallback)
  const loadingTimeout = setTimeout(() => {
    hideLoadingOverlay();
    console.warn("Loading timeout reached - hiding overlay");
  }, 30000);

  const productForm = document.querySelector("form[action='/cart/add']");
  const ringFormData = new FormData(productForm);
  const metalVariantId = Number(selectedMetalRingVariantId);

  let shape = selectedMetalRingShape;
  let details = sessionStorage.getItem("selectedCurrentRingDetails");
  
  let ringData = JSON.parse(details);
  let ringImage = filteredImages?.[0]?.url || '';
  if (details) {
    shape = ringData.shape;
    ringImage = ringData.imagePreview;
  }
  
  // Calculate total price for partial payment
  const metalRing = window.selectedMetalRing || selectedMetalRing || {};
  let totalPrice = metalRing?.price || 0;
  
  // Add birthstone prices
  const checkedBirthstones = getCheckedBirthstones();
  checkedBirthstones.forEach(() => {
    totalPrice += 600;
  });
  
  // Add diamond price if not Moissanite
  const isMoissaniteProduct = !!(window.productDetails && window.productDetails.isMoissanite);
  if (selectedDiamond?.finalAmount > 0 && !isMoissaniteProduct) {
    totalPrice += selectedDiamond.finalAmount;
  }
  
  // Get payment selection and Depo configuration
  const selectedPayment = (document.querySelector('input[name="payment-option"]:checked') || {}).value || 'full';
  const depoRuleId = 2005984; // Replace with your actual Depo rule ID for 50% payment
  const is50Percent = selectedPayment === 'deposit';
  
  // Helper function to create Depo properties for each item
  function createDepoProperties(itemPrice, productId = null) {
    const partPaymentAmount = is50Percent ? (itemPrice * 0.5) : 0;
    const ppPercentage = is50Percent ? 50.0 : 0;
    const partPaymentId = is50Percent ? depoRuleId : 'full';
    
    const formattedAmount = `₱${partPaymentAmount.toLocaleString('en-PH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
    
    const label = is50Percent ? "50% Down Payment" : "Full Payment Discount";
    const labelResult = is50Percent ? formattedAmount : "Use code pristinegold15";
    return {
      properties: {
        [label]: labelResult,
        "_part_payment_amount": partPaymentAmount,
        "_pp_percentage": ppPercentage,
        "_part_payment_id": partPaymentId,
        "_flow": "part_payment",
        "_deposit_charge_flow": "no_charge",
        "_deposit_charge_ratio": 0.0,
        "_cart_flow": "cart_v3"
      },
      part_payments: is50Percent ? depoRuleId : null,
      product_id: productId
    };
  }
  
  const items = [];
  
  // 🔮 Birthstones
  checkedBirthstones.forEach((stone) => {
    if (stone.variantId) {
      const birthstonePrice = 600;
      const depoProps = createDepoProperties(birthstonePrice);
      
      items.push({
        id: Number(stone.variantId),
        quantity: 1,
        properties: {
          ...depoProps.properties
        },
        part_payments: depoProps.part_payments,
        product_id: depoProps.product_id
      });
    }
  });

  // 💎 Diamond
  if(selectedDiamond){
    const diamondVariantId = await getDiamondVariantId(selectedDiamond);

    if (diamondVariantId) {
      const diamondPrice = selectedDiamond.finalAmount || 0;
      const initTable = meta?.product?.id || window.productDetails?.shopifyProductId;
      const depoProps = createDepoProperties(diamondPrice, initTable);
      
      items.push({
        id: Number(diamondVariantId),
        quantity: 1,
        properties: {
          ...depoProps.properties
        },
        part_payments: depoProps.part_payments,
        product_id: depoProps.product_id
      });
    }
  }

  // 🟢 Metal Ring
  if (metalVariantId) {
    const metalRingPrice = metalRing?.price || 0;
    const metalProductId = meta?.product?.id || window.productDetails?.shopifyProductId;
    const depoProps = createDepoProperties(metalRingPrice, metalProductId);
    
    const shapeValue = selectedDiamond.shape ?? shape;
    const capitalizedShape = shapeValue ? shapeValue.charAt(0).toUpperCase() + shapeValue.slice(1).toLowerCase() : shapeValue;

    items.push({
      id: metalVariantId,
      quantity: 1,
      properties: {
        "Selected Shape": capitalizedShape,
        "Engraving": engraving.value,
        ...depoProps.properties
      },
      part_payments: depoProps.part_payments,
      product_id: depoProps.product_id
    });
  }
  console.log("CARTED ITEMS",items);

  // ✅ Final validation
  if (items.length === 0) {
    // Clear timeout and hide loading overlay
    clearTimeout(loadingTimeout);
    hideLoadingOverlay();
    alert("❌ No valid items to add to cart.");
    return;
  }

  let errors = [];
  let successfulAdds = 0;
  for(const product of items){
    try {
      await addProductToCart(product);
      successfulAdds++;
    } catch (error) {
        errors.push({ product: product, error: error });
        console.log(`Error adding product ${product.id}: ${error.message}`);
    }

    // Wait 300ms between requests to be safe
    await new Promise(resolve => setTimeout(resolve, 300));
  }
  console.log(`${successfulAdds} products added to the cart.`);
  if (errors.length > 0) {
      console.log('Failed to add the following products:');
      errors.forEach(err => console.log(`Product ${err.product.id} failed due to: ${err.error.message}`));
  }

  // Clear timeout and hide loading overlay before redirecting
  clearTimeout(loadingTimeout);
  hideLoadingOverlay();

  // Clear diamond selection from session storage after successful order
  clearDiamondSelection();

  window.location.href = '/cart';
}

async function addProductToCart(product) {
  try {
    let requestBody;
    
    // Check if this product has Depo partial payment fields
    if (product.part_payments || product.product_id) {
      // Use singular format for Depo compatibility
      requestBody = {
        id: product.id,
        quantity: product.quantity,
        properties: product.properties,
        part_payments: product.part_payments,
        product_id: product.product_id
      };
      
      // Remove null/undefined values
      Object.keys(requestBody).forEach(key => {
        if (requestBody[key] === null || requestBody[key] === undefined) {
          delete requestBody[key];
        }
      });
    } else {
      // Use standard items array format for regular products
      requestBody = {
        items: [product]
      };
    }
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    const data = await response.json();
  } catch (error) {
    console.warn(`Could not add product ${product.id}:`, error.message);
  }
}


function fetchBirthStones() {
  console.log('🔮 Fetching birthstones...');
  const url = pristineParadigmApi + "/api/diamonds/birthstones";
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new TypeError("Expected JSON but received: " + contentType);
      }
      return response.json();
    })
    .then(data => {
      console.log('✅ Birthstones received:', data);
      birthStones = data;
      renderBirthstoneCheckboxes(birthStones);
      
      // Restore engraving and birthstone details after birthstones are rendered
      setTimeout(() => {
        if (typeof window.restoreEngravingAndBirthstoneDetails === 'function') {
          window.restoreEngravingAndBirthstoneDetails();
        } else if (typeof restoreEngravingAndBirthstoneDetails === 'function') {
          restoreEngravingAndBirthstoneDetails();
        }
      }, 100);
    })
    .catch(error => {
      console.error("Error at:", url);
      console.error("Fetch error:", error);
    });
}

function renderBirthstoneCheckboxes(data) {
  console.log('🎨 Rendering birthstones:', data);
  const container = document.getElementById("birthstone-list");
  if (!container) {
    console.error('❌ Birthstone container not found!');
    return;
  }
  console.log('✅ Container found:', container);
  container.innerHTML = ""; // clear if reloading
  
  // Add grid container styles
  container.style.display = "grid";
  container.style.gridTemplateColumns = "repeat(3, 1fr)";
  container.style.gap = "12px";
  container.style.alignItems = "center";

  data.forEach((stone, index) => {
    const checkboxId = `birthstone-${index}`;

    const html = `<div class="flex items-center space-x-3">
  <label class="relative flex items-center justify-center p-2 cursor-pointer" for="${checkboxId}">
    <input
      id="${checkboxId}"
      type="checkbox"
      name="birthStones[]"
      value="${stone.shopifyVariantId}"
      class="peer h-5 w-5 appearance-none border border-neutral-300 bg-white transition-all duration-150 cursor-pointer checked:bg-[#1C3C35] checked:border-[#1C3C35]"
    />
    <span class="pointer-events-none absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity duration-150">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" stroke-width="1">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
      </svg>
    </span>
  </label>
  <label for="${checkboxId}" class="cursor-pointer text-[12px] text-neutral-800">
    ${stone.birthmonth}
  </label>
</div>`;

    container.insertAdjacentHTML("beforeend", html);
  });

   // Set up delegation once
  const birthstoneList = document.getElementById("birthstone-list");
  birthstoneList.addEventListener("change", function (e) {
    if (e.target && e.target.matches('input[name="birthStones[]"]')) {
      const checkbox = e.target;
      if (checkbox.checked) {
        const checkedCount = birthstoneList.querySelectorAll('input[name="birthStones[]"]:checked').length;
        if (checkedCount > 2) {
          checkbox.checked = false; // prevent selecting more than 2
          checkbox.blur();
        }
      }
      if (typeof window.updateTotalPrice === 'function') {
        window.updateTotalPrice();
      }
    }
  });
}

function getCheckedBirthstones() {
  const selected = [];

  const checkboxes = document.querySelectorAll('input[name="birthStones[]"]:checked');

  checkboxes.forEach(cb => {
    selected.push({
      variantId: cb.value,
      name: cb.getAttribute('data-name'),
      price: 600
    });
  });

  return selected;
}

// Note: updateTotalPrice, getCheckedBirthstones, updateBuyButtonLabel, and changePriceValue 
// are now defined in metal-ring-redirect.js (which loads first) to avoid loading order issues

async function getDiamondVariantId(diamond) {
  if (diamond?.shopifyVariantId) {
    return diamond.shopifyVariantId;
  }

  try {
    const url = pristineParadigmApi + "/api/shopify/cart-diamond";
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify( diamond.id )
    });

    if (!response.ok) throw new Error("Diamond variant fetch failed");

    const data = await response.json();

    if (data) {
      return data;
    } else {
      throw new Error("No variantId returned from diamond API");
    }
  } catch (error) {
    console.error("❌ Failed to fetch diamond variant:", error);
    return null;
  }
}
